exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".primary-widget {\r\n    border: 1px solid #D9D9D9;\r\n    border-radius: 0px;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/shared/components/layout/simple-widget-layout/simple-widget-layout.component.css
// module id = ../../../../../src/app/shared/components/layout/simple-widget-layout/simple-widget-layout.component.css
// module chunks = main